// The base half of the per-worktree routing tripwire — the sibling of
// `hub-binding.ts`, over the same machinery in `worktree-binding.ts`. Separate
// files on disk is deliberate: a worktree may legitimately be bound to one hub
// AND one base (docs/reference/rekor-platform-contracts.md §3.3).

import { isValidBaseId } from './base-id.js';
import { createWorktreeBinding } from './worktree-binding.js';

const binding = createWorktreeBinding({
  filename: 'wayai-base-binding',
  isValidId: isValidBaseId,
  noun: 'base',
  idLabel: 'base id (must be a slug)',
  unbindCommand: 'wayai bases unbind',
  useCommand: 'wayai bases use',
});

export const getBaseBindingPath = binding.getBindingPath;
export const readBaseBinding = binding.readBinding;
export const writeBaseBinding = binding.writeBinding;
export const clearBaseBinding = binding.clearBinding;
export const autoBindBaseIfUnbound = binding.autoBindIfUnbound;
export const assertBaseMatchesBinding = binding.assertMatchesBinding;
export const assertNoBindingBlocksBaseCreation = binding.assertNoBindingBlocksCreation;
